/**
 * Generate unique ControlData.Name values for new controls in Control Designer v3.
 */

import { isValidJsIdentifier } from './controlDesignerScopeScript.js';
import {
    listActionSetMembers,
    listNamedControlsInDesign,
} from './controlDesignerScopeScriptCompletion.js';

/**
 * @param {string} prefix
 * @returns {boolean}
 */
export function isUsableNamePrefix(prefix) {
    const trimmed = String(prefix || '').trim();
    return trimmed !== '' && isValidJsIdentifier(trimmed);
}

/**
 * @param {unknown} designRoot
 * @param {unknown} [actionSet]
 * @returns {Set<string>}
 */
export function collectReservedControlNames(designRoot, actionSet) {
    const reserved = new Set();

    for (const item of listNamedControlsInDesign(designRoot))
        reserved.add(item.name);

    for (const item of listActionSetMembers(actionSet))
        reserved.add(item.name);

    return reserved;
}

/**
 * @param {string} prefix
 * @param {unknown} designRoot
 * @param {unknown} [actionSet]
 * @returns {string}
 */
export function generateUniqueName(prefix, designRoot, actionSet) {
    const namePrefix = String(prefix || '').trim();
    if (!isUsableNamePrefix(namePrefix))
        return '';

    const reserved = collectReservedControlNames(designRoot, actionSet);

    for (let n = 1; n < 100000; n++) {
        const candidate = `${namePrefix}${n}`;
        if (!reserved.has(candidate))
            return candidate;
    }

    return '';
}
